module.exports = __webpack_public_path__ + "static/media/Portrait-10017.872fe5b0.jpg";